export function changeUrl(url) {

    try {
        window.history.pushState("", "", url);
    } catch (error) {

    }

}

export function changeTitle(title) {
    try {
        document.title = title
    } catch (error) {

    }
}

export function changeUrlForMember(member) {

    let url = member.member_post_name;
    let title = member.member_seo_title;

    if (title.length <= 1) {
        title = member.member_post_title;
    }

    if (url.charAt(0) !== '/') {
        url = '/' + url;
    }

    url = '/listing' + url;

    changeUrl(url);
    changeTitle(title);

}
